import React, { useCallback, useEffect, useState } from 'react';
import {
  AppRemixIcon,
  AppModal,
  AppSingleSelect,
} from '@/layout/AppComponents';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../Sidebar/Sidebar';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import { axiosPath, path } from '../../../../routing/helpers/router';
import ErrorHandler from '../../../components/error/ErrorHandler';
import Translator from '../../../components/helpers/Translator';
import useIsMounted from '../../../components/hooks/useIsMounted';
import UserModalExportPermissions from './Sidebar/UserModalExportPermissions';

const UserManagementModuleSidebar = (props) => {
  const { moduleBridgeHex } = useParams();
  const { isUserAdd, permissionLevel } = props;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const [userUsers, setUserUsers] = useState();
  const [userAddModal, setUserAddModal] = useState(false);
  const [showExportExcelModal, setShowExportExcelModal] = useState(false);
  const permissions = useSelector((state) => state.auth.permissions.client);

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  const handleLoadUsersSelector = useCallback(async () => {
    await axios
      .get(axiosPath('api_r_user_module_userManagement_user_selector_add'))
      .then((r) => {
        if (isMounted.current) {
          setUserUsers(r.data);
        }
      })
      .catch((e) => dispatch(ErrorHandler(e, history)));
  }, [moduleBridgeHex]);

  useEffect(() => {
    handleLoadUsersSelector();
  }, []);

  return (
    <>
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        {permissionLevel <= 1 && (
          <>
            <Accordion>
              <ul>
                {/* ADD */}
                <li className="sidebar-element">
                  {isUserAdd === true ? (
                    <div
                      className="sidebar-element text-light"
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-userManagement"
                          name="module.um.already-adding-user"
                        />
                      )}
                    >
                      <AppRemixIcon icon="user-add" className="sidebar-icon" />{' '}
                      <span className="sb-title">
                        <Translator
                          file="module-userManagement"
                          name="module.um.user-add"
                        />
                      </span>
                    </div>
                  ) : (
                    <div
                      className={`sidebar-element ${
                        userUsers?.length > 0 ? '' : 'text-light'
                      }`}
                      onClick={() =>
                        navigate(
                          path({
                            name: 'user_module_userManagement_add',
                            params: {
                              moduleBridgeHex,
                              userName: userUsers[0].label,
                            },
                          })
                        )
                      }
                      title={`${
                        userUsers?.length > 0
                          ? ReactDOMServer.renderToString(
                              <Translator
                                file="module-userManagement"
                                name="module.um.user-add"
                              />
                            )
                          : ReactDOMServer.renderToString(
                              <Translator
                                file="module-userManagement"
                                name="module.um.cannot-add-users"
                              />
                            )
                      }`}
                    >
                      <AppRemixIcon icon="user-add" className="sidebar-icon" />{' '}
                      <span className="sb-title">
                        <Translator
                          file="module-userManagement"
                          name="module.um.user-add"
                        />
                      </span>
                    </div>
                  )}
                </li>
                <li className="divider" />
                {/* CLONE */}
                <li className="sidebar-element">
                  {isUserAdd === true ? (
                    <div className="sidebar-element text-light">
                      <AppRemixIcon icon="group" className="sidebar-icon" />{' '}
                      <span className="sb-title">
                        <Translator
                          file="module-userManagement"
                          name="module.um.clone-user"
                        />
                      </span>
                    </div>
                  ) : (
                    <div
                      className={`sidebar-element ${
                        userUsers?.length > 0 ? '' : 'text-light'
                      }`}
                      onClick={() =>
                        userUsers?.length > 0
                          ? setUserAddModal(!userAddModal)
                          : undefined
                      }
                      title={`${
                        userUsers?.length > 0
                          ? ReactDOMServer.renderToString(
                              <Translator
                                file="module-userManagement"
                                name="module.um.user-add"
                              />
                            )
                          : ReactDOMServer.renderToString(
                              <Translator
                                file="module-userManagement"
                                name="module.um.cannot-add-users"
                              />
                            )
                      }`}
                    >
                      <AppRemixIcon icon="group" className="sidebar-icon" />{' '}
                      <span className="sb-title">
                        <Translator
                          file="module-userManagement"
                          name="module.um.clone-user"
                        />
                      </span>
                    </div>
                  )}
                </li>
                <li className="divider" />
                {permissions?.userManagement?.exportPermissions &&
                  permissions?.userManagement?.exportPermissions === true && (
                    <li className="sidebar-element">
                      <div
                        className="sidebar-element"
                        onClick={() => setShowExportExcelModal(true)}
                        title="Exportar permisos"
                      >
                        <AppRemixIcon
                          icon="file-excel-2"
                          className="sidebar-icon"
                        />{' '}
                        <span className="sb-title">
                          {/* <Translator
                              file="module-userManagement"
                              name="module.um.clone-user"
                          /> */}
                          Exportar permisos
                        </span>
                      </div>
                    </li>
                  )}
                {/** > EXPORT EXCELS */}
              </ul>
            </Accordion>

            {/* > ADD MODAL */}
            <Formik
              initialValues={{
                user: auth.user.user,
              }}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
              onSubmit={(v) =>
                navigate(
                  path({
                    name: 'user_module_userManagement_add',
                    params: {
                      moduleBridgeHex,
                      userName: v.user,
                    },
                  })
                )
              }
            >
              {({ setFieldValue, handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <AppModal
                    show={userAddModal}
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-userManagement"
                        name="module.um.select-reference-user"
                      />
                    )}
                    icon={<AppRemixIcon icon="user-add" />}
                    onClose={() => setUserAddModal(false)}
                    size="lg"
                    isConfirmBtn
                    confirmBtnText={ReactDOMServer.renderToString(
                      <Translator
                        file="module-userManagement"
                        name="module.um.continue"
                      />
                    )}
                    onConfirm={handleSubmit}
                  >
                    <AppSingleSelect
                      placeholder={ReactDOMServer.renderToString(
                        <Translator
                          file="module-userManagement"
                          name="module.um.select-reference-user"
                        />
                      )}
                      options={userUsers}
                      icon={<AppRemixIcon icon="group" />}
                      onChange={(value) => setFieldValue('user', value)}
                      value={values.user}
                    />
                  </AppModal>
                </form>
              )}
            </Formik>
            {/* < ADD MODAL */}

            {/* > EXPORT EXCEL MODAL */}
            <UserModalExportPermissions
              showExportExcelModal={showExportExcelModal}
              setShowExportExcelModal={setShowExportExcelModal}
              userUsers={userUsers}
              moduleBridgeHex={moduleBridgeHex}
            />
          </>
        )}
      </Sidebar>
    </>
  );
};

export default UserManagementModuleSidebar;
